// extracted by mini-css-extract-plugin
export default {"component":"BookingList_component__xfdn9"};